/**
 * Coerce export cell values so Excel/CSV treat amounts/qty as real numbers
 * (summable), while leaving codes, dates, and mixed text as text.
 */
export function coerceExportCellValue(value) {
    if (value === null || value === undefined || value === 'undefined' || value === 'null') {
        return '';
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : '';
    }

    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'bigint') {
        return Number(value);
    }

    if (typeof value !== 'string') {
        return value;
    }

    const trimmed = value.trim();
    if (trimmed === '') {
        return '';
    }

    // Dates / times stay text
    if (/^\d{1,2}[-/]\d{1,2}[-/]\d{2,4}$/.test(trimmed)) {
        return trimmed;
    }
    if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}/.test(trimmed)) {
        return trimmed;
    }
    if (/^\d{1,2}:\d{2}(:\d{2})?(\s*[AaPp][Mm])?$/.test(trimmed)) {
        return trimmed;
    }

    // Preserve zero-padded codes (e.g. "00123")
    if (/^0\d+$/.test(trimmed)) {
        return trimmed;
    }

    let normalized = trimmed
        .replace(/^(?:₹|Rs\.?\s*|INR\s*|\$|€|£)\s*/i, '')
        .replace(/\s/g, '');

    // Strip thousand separators (Western / Indian grouping)
    if (normalized.includes(',')) {
        normalized = normalized.replace(/,/g, '');
    }

    if (!/^-?(?:\d+\.?\d*|\.\d+)$/.test(normalized)) {
        return trimmed;
    }

    const number = Number(normalized);
    return Number.isFinite(number) ? number : trimmed;
}
